/**
 * Započtení dříve zaplacených vzorků při objednávce nad 500 €.
 *
 * PRAVIDLO (převzato ze starého webu):
 * „Bei einer Bestellung ab 500 € werden zuvor gezahlte Musterkosten von 3 €
 * bis maximal 10 € automatisch angerechnet." Okno je 12 měsíců.
 *
 * JAK:
 * Obchod není Shopify Plus, takže nelze měnit ceny v košíku. Kredit se proto
 * uplatní jako jednorázový slevový kód: beptum-admin zná historii objednávek
 * (části `mb` v `na_order_parts`), spočítá nárok, vytvoří kód přes Admin API
 * a tenhle skript ho v košíku uplatní. Kód je omezený na zákazníka, na jedno
 * použití a s krátkou platností.
 *
 * Bezplatné vzorníky do 3 € řeší NATIVNÍ automatická sleva Shopify
 * („Musterkarten bis 3 € gratis" na kolekci Musterfarben) — tenhle skript s ní
 * nemá nic společného, jen se s ní musí umět kombinovat (proto je kód
 * order-level a automatická sleva product-level).
 *
 * OSOBNÍ SLEVY (Katrin/Petr 26. 10. 2026, úkol 74617): sleva založená v beptum-admin (Benutzer → Rabatte) jen pro
 * tohoto zákazníka se uplatní sama — zákazník nic nezadává, platí i pod 500 €. Slevy se NESČÍTAJÍ: server vrátí
 * jen nejvyšší (osobní sleva × započtení vzorků) a skript nechá v košíku jen ji. Naše kódy (MUSTER-, osobní kód)
 * spravuje skript; VERSANDFREI- a MUSTERGRATIS- (doprava, vzorníky zdarma) nechává; cizí kód zadaný zákazníkem
 * nepřepisuje.
 *
 * Bezpečnostní zásady:
 *  - běží jen pro přihlášeného zákazníka (host historii ani osobní slevu nemá), na každé stránce s košíkem
 *    (i košík v panelu → pokladna); stránku obnoví jen na /cart,
 *  - o nároku rozhoduje VÝHRADNĚ server, klient posílá jen mezisoučet a identitu,
 *  - když už je v košíku cizí slevový kód, nic neděláme (Shopify pustí jen jeden),
 *  - na jeden stav košíku (token + částka) se server ptá jen jednou — pojistka proti smyčce v sessionStorage.
 */
(function () {
  // kódy, které skript nechává (doprava zdarma, vzorníky do 3 € zdarma) — nejsou to slevy na objednávku
  const KEEP = ['VERSANDFREI-', 'MUSTERGRATIS-'];
  const MANAGED = ['MUSTER-'];

  function apiBase() {
    // stejný zdroj jako konfigurátory (Theme settings → Beptum → Beptum Admin API base)
    const el = document.querySelector('[data-bp-admin-api-base]');
    return (window.bpAdminApiBase || (el && el.getAttribute('data-bp-admin-api-base')) || '').replace(/\/+$/, '');
  }

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
    } catch (e) {
      /* bez úložiště pokaždé — server odpovídá stejně, jen víc dotazů */
    }
    return true;
  }

  const starts = (code, list) => list.some((p) => code.toUpperCase().startsWith(p));
  let running = false;

  async function applyBestDiscount() {
    if (running) return;
    const base = apiBase();
    const customerId = window.bpCustomerId || null;
    if (!base || !customerId) return; // bez adresy API nebo bez přihlášení nemá smysl ptát se

    running = true;
    try {
      let cart;
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        cart = await res.json();
      } catch (e) {
        return; // výpadek sítě nesmí rozbít košík
      }
      if (!cart || !cart.items || cart.items.length === 0) return;

      // jeden dotaz na stav košíku — po vložení kódu se změní částka a zeptáme se znovu jen jednou
      if (!once('bpBestDiscount:' + cart.token + ':' + cart.items_subtotal_price + ':' + cart.item_count)) return;

      const codes = (cart.discount_codes || []).map((d) => String(d.code || '')).filter(Boolean);
      const foreign = codes.filter((c) => !starts(c, KEEP) && !starts(c, MANAGED));

      let data;
      try {
        const res = await fetch(base + '/api/muster/credit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            // před slevami na objednávku — osobní sleva i zápočet se počítají z hodnoty zboží
            subtotal: (cart.items_subtotal_price || cart.total_price || 0) / 100,
            customer_id: String(customerId),
            lines: cart.items.map((i) => ({ product_id: i.product_id, total: (i.final_line_price || 0) / 100 })),
            locale: window.bpLocale || document.documentElement.lang || 'de',
          }),
        });
        data = await res.json();
      } catch (e) {
        return;
      }
      if (!data || !data.success || !data.code) return;

      const best = String(data.code);
      if (codes.some((c) => c.toUpperCase() === best.toUpperCase())) return; // už platí
      // cizí kód zadaný zákazníkem (jiný než náš nejlepší) nepřepisujeme
      if (foreign.some((c) => c.toUpperCase() !== best.toUpperCase())) return;

      const next = codes.filter((c) => starts(c, KEEP)).concat(best);
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: next.join(',') }),
        });
        if (res.ok && window.location.pathname.includes('/cart') && once('bpBestDiscountReload:' + cart.token + ':' + best)) {
          window.location.reload();
        }
      } catch (e) {
        /* ignorovat — zkusí se při další změně košíku */
      }
    } finally {
      running = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBestDiscount);
  } else {
    applyBestDiscount();
  }
  // Horizon po změně košíku (přidání, množství, mazání) vysílá cart:update — dorovnat bez načtení stránky
  document.addEventListener('cart:update', () => setTimeout(applyBestDiscount, 300));
})();
